export default "__VITE_ASSET__BydODO2k__"